import api from './api'

/**
 * Serviço de Feedbacks
 */
export default {
  /**
   * Enviar feedback
   */
  send(feedbackData) {
    return api.post('/api/feedbacks', feedbackData)
  },

  /**
   * Feedbacks recebidos
   */
  getReceived(params = {}) {
    return api.get('/api/feedbacks/received', { params })
  },

  /**
   * Feedbacks enviados
   */
  getSent(params = {}) {
    return api.get('/api/feedbacks/sent', { params })
  },

  /**
   * Reagir a um feedback recebido
   */
  react(feedbackId, reactionData) {
    return api.put(`/api/feedbacks/${feedbackId}/react`, reactionData)
  },

  /**
   * Excluir feedback
   */
  delete(feedbackId) {
    return api.delete(`/api/feedbacks/${feedbackId}`)
  },
}
